
import { computed, getCurrentInstance, ref, useContext, watch } from '@nuxtjs/composition-api'
// @ts-expect-error
import { SwiperOptions } from 'swiper/types'
// eslint-disable-next-line import/no-named-as-default
import VueEasyLightbox from 'vue-easy-lightbox'
import { useImage } from '~/composables'

import ThumbsSlider from '~/components/atoms/ThumbsSlider.vue'
import BaseButton from '~/components/BaseButton.vue'
import { KNOWN_PLACEHOLDER_PATTERNS } from '~/helpers/images/patterns'

export default {
  name: 'LightboxViewer',
  components: {
    ThumbsSlider,
    BaseButton,
    VueEasyLightbox
  },
  props: {
    images: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    activeSlideIndex: {
      type: Number,
      default: 0
    }
  },
  setup (props) {
    const context = useContext()
    const { getMagentoImage } = useImage()
    const activeThumb = ref<number>(0)
    const lightbox = ref(null)
    const thumbs = ref(null)
    const activeImageIndex = ref<number>(props.activeSlideIndex)

    const thumbsOptions = ref<SwiperOptions>({
      initialSlide: activeThumb.value,
      spaceBetween: 16,
      slidesPerView: 'auto',
      grabCursor: true,
      freeMode: true,
      breakpoints: {
        768: {
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          slidesPerView: 5
        }
      }
    })

    const bigImages = computed(() => {
      return props.images.map((i) => {
        if (KNOWN_PLACEHOLDER_PATTERNS.some(regex => regex.test(i.big.url))) {
          return i.big.url
        }

        return context.$img(getMagentoImage(i.big.url), {
          format: 'webp'
        })
      })
    })

    const thumbsImages = computed(() => props.images.map(i => ({
      url: i.mobile.url,
      alt: i.alt
    })))

    const zoomValue = computed(() => Math.round(lightbox.value.scale * 100) + '%')

    function onThumbChanged (index) {
      activeImageIndex.value = index
    }

    watch(() => activeImageIndex, (newValue) => {
      activeThumb.value = newValue.value
    }, { immediate: true })

    watch(() => props.activeSlideIndex, (newVal) => {
      activeImageIndex.value = newVal
    })

    watch(() => lightbox.value?.imgIndex, () => {
      if (lightbox.value) {
        activeImageIndex.value = lightbox.value?.imgIndex
      }
    })

    return {
      thumbsOptions,
      activeThumb,
      bigImages,
      thumbsImages,
      thumbs,
      zoomValue,
      onThumbChanged,
      lightbox,
      activeImageIndex
    }
  }
}
